var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHrApiLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 99,
    viewBox: "0 0 95 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2638_3298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8835 37.7831L15.7992 39.1859L15.5749 49.9322L7.99609 51.2474L8.53328 23.4998L16.1121 22.1846L15.9018 33.0072L23.9848 31.6031L24.1977 20.7805L31.7347 19.4717L31.1962 47.2257L23.6592 48.5345L23.8835 37.7831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6924 42.4457L50.2711 43.9082L44.5623 35.2197L43.5943 35.3885L43.4081 45.099L35.8711 46.4078L36.4425 18.6145L46.7592 16.8232C51.0541 16.078 54.5014 16.7039 56.2485 19.2848C57.181 20.6635 57.6054 22.3684 57.5154 24.1216C57.3495 27.4287 55.3832 30.85 51.5608 32.819L58.6924 42.4457ZM46.521 28.9889C49.1739 28.5294 50.3788 26.4639 50.1001 24.8529C49.8809 23.5834 48.7419 22.5195 46.6793 22.8775L43.6476 23.4044L43.4892 29.5158L46.521 28.9889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9046 74.4757L28.5153 76.1057L26.155 83.2708L18.1543 84.6597L28.7966 54.8821L38.5608 53.1924L48.1756 79.4547L40.1331 80.8511L37.9046 74.4757ZM33.431 59.1337L32.6062 63.1491L30.6184 69.4586L36.0498 68.5153L34.4167 62.8406L33.725 59.0892L33.431 59.1337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8166 77.7741L50.4062 79.0614L50.9434 51.3138L60.7533 49.6101C68.4234 48.3177 72.0025 52.7141 71.8276 57.7223C71.6465 62.6924 67.7456 68.2287 60.4252 69.4995L57.9825 69.9248L57.8166 77.7741ZM64.5503 59.0248C64.62 56.9187 63.3835 55.0398 60.6469 55.5146L58.1206 55.9538L57.9623 64.3174L60.4885 63.8781C63.0934 63.4249 64.487 61.1309 64.5503 59.0248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7755 46.7092L84.2707 45.4092L83.712 73.2787L76.2168 74.5799L76.7755 46.7092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03315 99L0 94.3549V15.9539L88.963 0L95 4.64767V83.0436L85.9845 84.7231L85.9465 94.4983L56.7486 90.2696L6.03315 99ZM1.53679 93.5957L6.43604 97.3712L56.7334 88.7144L84.4223 92.7299L84.4578 83.4447L93.4683 81.7664V5.40556L88.5703 1.63513L1.53679 17.2425V93.5957Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2638_3298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 99,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrApiLogo);
export default __webpack_public_path__ + "static/media/HRApiLogo.29877b5306ad6473539771ea57588fed.svg";
export { ForwardRef as ReactComponent };